import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Team from '../Components/Team/Team';
import Process from '../Components/Process/Process';
import ClientsCarousel from '../Components/ClientsCarousel/ClientsCarousel';
import axios from 'axios';
import { BASE_URL } from '../Config/config';
import Skills from '../Components/Skills/Skills';
import Breadcrumb from '../Components/Breadcrumb';
import WhatWeDo from '../Components/WhatWeDo';
import ProvideImg from "../Assets/Images/about-2.png";
import LogoPresentation from '../Assets/Images/Fusion.png'
import Newsletter from '../Components/Newsletter';
import AboutSection from '../Components/AboutSection';

function About() {

  const breadcrumbLinks = [
    { label: 'Home', url: '/' },
    { label: 'About' },
  ];

  return (
    <>
      <Helmet>
        <title>About Us – Fusion Hub</title>
        <meta name="description" content="Learn more about Fusion Hub, our mission, vision, and the expert team driving innovation in engineering, IT, and business services." />
      </Helmet>
      <Breadcrumb pageTitle="About" breadcrumbLinks={breadcrumbLinks} />

      {/* <div
                className="sbs-what-riyaqas pd-default-120 "
            >
                <div className="container">
                    <div className="row">
                        <div
                            className="col-lg-6 wow fadeInRight animated"
                            data-wow-duration="1s"
                            data-wow-delay="0.3s"
                        >
                            <img src={ProvideImg} alt="img" />
                        </div>

                        <div className="col-xl-5 col-lg-6 desktop-center-item">
                            <div
                                className="desktop-center-area wow fadeInLeft animated"
                                data-wow-duration="1s"
                                data-wow-delay="0.3s"
                            >
                                <div className="section-title style-two">
                                    <h2 className="title">
                                        What is <span>FusionHub?</span>
                                    </h2>
                                    <p>
                                        FusionHub One of the best Software Development company. FusionHub is at the forefront as the most innovative web development company. Our cost efficient and structured teamwork justifies our position. Our clients count on our offshore business solutions on a regular basis from concept.
                                    </p>
                                    <p>Design to development, testing & implementation, our team is here to support and guide you every step of the way. FusionHub One of the best Software Development company.</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

      <AboutSection />

      <div className="logo-presentation-area pd-default-120">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="logo-content header-inner-detail">
                <div className="section-title mb-2">
                  <div className="title">Our Brand Identity</div>
                </div>
                <p>
                  The <span className="highlight">Fusion Hub</span> logo symbolizes the company’s identity and values through its atomic design. At the core, the nucleus represents Fusion Hub itself serving as the central force of innovation, strategic leadership, and unified purpose. Surrounding it, the three orbiting electrons embody the foundational pillars of the company: Engineering Expertise, reflecting precision and problem solving rooted in consultancy; IT & Digital Solutions, highlighting innovative, tech driven transformation; and Dedicated Talent & Collaboration, showcasing the strength of your team, adaptability, and long term partnership with clients.
                </p>
              </div>
            </div>
            <div className="col-lg-5 col-md-12">
              <div className="logo-showcase">
                <div className="logo-container">
                  <img src={LogoPresentation} alt="FusionHub Logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
                 .logo-presentation-area {
                   background: linear-gradient(135deg, #f9f9f9 0%, #f0f0f0 100%);
                   color: #333;
                   position: relative;
                   overflow: hidden;
                 }
                 
                 .logo-content {
                   padding-right: 50px;
                   margin-bottom: 30px;
                 }
                 
                 .logo-showcase {
                   display: flex;
                   justify-content: center;
                   align-items: center;
                 }
                 
                 .logo-container {
                   background-color: white;
                   border-radius: 20px;
                   padding: 20px;
                   box-shadow: 0 15px 30px rgba(0, 0, 0, 0.08);
                   text-align: center;
                   position: relative;
                   z-index: 2;
                   transition: transform 0.3s ease;
                 }
                 
                 .logo-container:hover {
                   transform: translateY(-10px);
                 }
                 
                 .main-logo {
                   max-width: 100%;
                   height: auto;
                   margin-bottom: 25px;
                 }
                 
                 .logo-icon {
                   max-width: 120px;
                   margin-bottom: 20px;
                 }
                 
                 .highlight {
                   color: #ff7e5f;
                   font-weight: 600;
                 }
                 
                 .logo-name {
                   font-size: 32px;
                   font-weight: 700;
                   color: #333;
                   margin-top: 15px;
                 }
                 
                 .tagline {
                   font-size: 16px;
                   color: #666;
                   font-style: italic;
                 }
                 
                 @media (max-width: 768px) {
                   .logo-content {
                     padding-right: 0;
                     text-align: center;
                   }
                   
                   .section-title:after {
                     left: 50%;
                     transform: translateX(-50%);
                   }
                 }
               `}</style>

      {/* <WhatWeDo /> */}


      {/* We Are Different With Others! */}
      <div className="sbst-skill-area pd-default-120 ">
        <div className="container">
          <div className="row">
            <div className=" col-lg-12 section-title style-two">
              <h2 className="fs-5 title text-center"><span>We</span> Are Different With Others!</h2>
            </div>

            <div className="col-lg-7">
              <div className="section-title">
                <p>We know this current era every third organization is a web solution provider who promises to deliver the solution at cheap rates with super quality. But still we are different from others because we take every project as our first and final project. We put all our efforts and skills to make every project unique, quality enabled and cost effective. We bring a fresh approach in the implementation life cycle by enabling end users to participate in each phase of the project, so both parties can achieve the expected goals and objectives of the project.</p>

                <p>In order to meet the quality work constraint we take a single project at one time and at one phase. We do not run behind money and profit making projects, we believe in making relationships with our clients not only profit.
                </p>
              </div>
            </div>
            <Skills />
          </div>
        </div>
      </div>

      {/* <Process /> */}

      {/* <ClientsCarousel /> */}

      <Newsletter />
    </>
  )
}

export default About